// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ceey","newExpiryDate":"styles_newExpiryDate__26laq","footer":"styles_footer__3EsRQ"};